// extracted by mini-css-extract-plugin
export default {"header":"MIC7x"};